import PieChart from "components/charts/PieChart";
import {pieChartData, pieChartOptions} from "variables/charts";
import Card from "components/card";
import React, {useEffect, useState} from "react";
import useAsyncEffect from "use-async-effect";
import axios from "axios";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";

const EnergySavingsConsumptionGraph = () => {

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValueuname = AES.decrypt(Username, secretKey).toString(enc.Utf8);
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);
    const navigate = useNavigate();

    let [productName, setProductName] = useState("Immensa UCP 9W")
    let [pId, setProductId] = useState("")
    let [refreshData, setRefreshData] = useState(true)
    let [total, setTotal] = useState(0)

    let [dataCount, setDataCount] = useState([]);
    let [options, setOptions] = useState([]);
    let [productCatalog, setProductCatalog] = useState([])

    const [pieChartDataValues, setPieChartData] = useState([]);
    const [unit, setUnits] = useState([]);

    let [isLoading, setIsLoading] = useState(true)

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }


    function getEnergySavingsWithUnit(unit) {
        setIsLoading(true)
        let totalData = 0
        if ((accesscontrollevel.toString() === "1") || (accesscontrollevel.toString() === "5")) {
            var chartLabels = [];
            var count = [];
            setProductId(unit)
            pId = unit
            if (unit === null || unit === undefined || unit === "") {
                unit = "Lighting"
                setProductId("Lighting")
            }
            var url = CROMPTON_ANALYTICS_URL + "v1/energy/consumption/category/getByUnit/" + unit
            //console.log(url)

            axios({
                method: "GET", url: url, headers: {
                    Authorization: decryptedValue,
                }

            }).then((res) => {
                //console.log(res.data)
                // Sort the data in descending order by energySaved
                const sortedData = res.data.sort((a, b) => b.energyConsumed - a.energyConsumed);
                for (var i = 0; i < sortedData.length; i++) {
                    chartLabels.push(sortedData[i].unit);
                    count.push(sortedData[i].energyConsumed);
                    totalData = totalData + sortedData[i].energyConsumed
                }

                setPieChartData(count);
                setUnits(chartLabels)
                setTotal(totalData)

                sessionStorage.setItem("productUnit", unit)

                setDataCount(count)
                dataCount = count
                setOptions(chartLabels)
                options = chartLabels

                setIsLoading(false)

                //setProductCatalog(JSON.parse(sessionStorage.getItem("productCatalogArray")))
                //productCatalog = JSON.parse(sessionStorage.getItem("productCatalogArray"))
                setRefreshData(false)

                /*localStorage.setItem("units", JSON.stringify(chartLabels))
                localStorage.setItem("unitCounts", JSON.stringify(count))*/

                /*console.log("Data labels: ", chartLabels)
                console.log("Data values: ", count)*/

            }).catch((error) => {
                setIsLoading(false)
                //console.log(error)
                if (error.response.data.status === "401" || error.response.data.status === "403") {
                    handleLogOut();
                }
            })

        } else {
            //console.log("Inside stats non admin")
            //setErrorMessage("You do not have permission to view this. Please contact admin.")
        }
    }

    function getEnergySavingsAll() {
        setIsLoading(true)
        let totalData = 0
        if ((accesscontrollevel.toString() === "1") || (accesscontrollevel.toString() === "5")) {
            var chartLabels = [];
            var count = [];

            var url = CROMPTON_ANALYTICS_URL + "v1/energy/savings/category/getAll"
            //console.log(url)

            axios({
                method: "GET", url: url, headers: {
                    Authorization: decryptedValue,
                }

            }).then((res) => {
                //console.log(res.data)
                // Sort the data in descending order by energySaved
                const sortedData = res.data.sort((a, b) => b.energyConsumed - a.energyConsumed);
                for (var i = 0; i < sortedData.length; i++) {
                    chartLabels.push(sortedData[i].unit);
                    count.push(sortedData[i].energyConsumed);
                    totalData = totalData + sortedData[i].energyConsumed
                }

                setPieChartData(count);
                setUnits(chartLabels)
                setTotal(totalData)

                //sessionStorage.setItem("productUnit", unit)

                setDataCount(count)
                dataCount = count
                setOptions(chartLabels)
                options = chartLabels

                setIsLoading(false)

                /*setProductCatalog(JSON.parse(sessionStorage.getItem("productCatalogArray")))
                productCatalog = JSON.parse(sessionStorage.getItem("productCatalogArray"))*/
                setRefreshData(false)

                /*localStorage.setItem("units", JSON.stringify(chartLabels))
                localStorage.setItem("unitCounts", JSON.stringify(count))*/

                /*console.log("Data labels: ", chartLabels)
                console.log("Data values: ", count)*/

            }).catch((error) => {
                setIsLoading(false)
                //console.log(error)
                if (error.response.data.status === "401" || error.response.data.status === "403") {
                    handleLogOut();
                }
            })

        } else {
            //console.log("Inside stats non admin")
            //setErrorMessage("You do not have permission to view this. Please contact admin.")
        }
    }

    useAsyncEffect(() => {

        // Retrieve product catalog array from sessionStorage
        const productCatalogArray = JSON.parse(sessionStorage.getItem("productCatalogArray"));

        // Extract unique items based on a specific key, e.g., "productId"
        const uniqueProducts = Array.from(new Map(
            productCatalogArray.map(item => [item.unit, item]) // Use the key to ensure uniqueness
        ).values());

        //console.log(uniqueProducts)

        // Set the unique products to setProductCatalog
        setProductCatalog(uniqueProducts);
        productCatalog = uniqueProducts

        //console.log(sessionStorage.getItem("productUnit"))
        if (sessionStorage.getItem("productUnit") !== null && sessionStorage.getItem("productUnit") !== "" && sessionStorage.getItem("productUnit") !== "all") {
            //setProductName(sessionStorage.getItem("productUnit"))
            getEnergySavingsWithUnit(sessionStorage.getItem("productUnit"))
        }else{
            getEnergySavingsAll()
        }


    }, [pId])

    function handleChangeProductDropDown(event) {
        const selectBox = document.getElementById("productUnitDropdown2")
        pId = selectBox.options[selectBox.selectedIndex].value
        setProductId(selectBox.options[selectBox.selectedIndex].value)
        sessionStorage.setItem("productUnit", pId)
        //setProductName(event.target.option);
        //sessionStorage.setItem('productName', event.target.option);

        if(pId !== "all"){
            getEnergySavingsWithUnit(pId)
        }else{
            getEnergySavingsAll()
        }

    }

    return (
        <Card extra="rounded-[20px] p-3">
            <div className="flex flex-row justify-between px-3 pt-2">
                <div>
                    <h4 className="text-lg font-bold text-navy-700 dark:text-white">
                        Energy Consumption Info
                    </h4>
                </div>
                <div className="mb-6 flex items-center justify-center">
                    <select id="productUnitDropdown2" onChange={handleChangeProductDropDown} key={productName}
                            value={pId}
                            className="mb-3 flex items-center justify-center text-sm font-bold text-gray-600 me-2 hover:cursor-pointer dark:!bg-navy-800 dark:text-white">
                        <option onClick={() => getEnergySavingsAll()} value="all">All</option>
                        {
                            productCatalog.map((Val) => {
                                    return (
                                        <option value={Val.unit} key={Val.unit}>{Val.unit}</option>
                                    )
                                }
                            )
                        }
                    </select>
                </div>
            </div>

            <br/>

            {!isLoading &&
                <div className="mb-auto flex h-[200px] w-full items-center justify-center">
                    <PieChart options={{
                        labels: options,
                        colors: [ "#FBE29F", "#C6D68F","#9BBFE0", "#E8A09A"],
                        chart: {
                            width: "50px",
                        },
                        states: {
                            hover: {
                                filter: {
                                    type: "none",
                                },
                            },
                        },
                        legend: {
                            show: false,
                        },
                        dataLabels: {
                            enabled: false,
                        },
                        hover: {mode: null},
                        plotOptions: {
                            donut: {
                                expandOnClick: false,
                                donut: {
                                    labels: {
                                        show: false,
                                    },
                                },
                            },
                        },
                        fill: {
                            colors: [ "#FBE29F", "#C6D68F","#9BBFE0", "#E8A09A"],
                        },
                        tooltip: {
                            enabled: true,
                            theme: "dark",
                            style: {
                                fontSize: "12px",
                                fontFamily: undefined,
                                backgroundColor: "#000000"
                            },
                        },
                    }
                    } series={dataCount}/>
                </div>
            }
            <div
                className="flex flex-row !justify-between rounded-2xl px-6 py-3 shadow-2xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
                <div className="flex flex-col items-center justify-center">
                    <div className="flex items-center justify-center">
                        <div className="h-2 w-2 rounded-full bg-[#9BBFE0]"/>
                        <p className="ml-1 text-sm font-normal text-gray-600">{unit[0]}</p>
                    </div>
                    <p className="mt-px text-xl font-bold text-navy-700  dark:text-white">
                        {(((pieChartDataValues[0] / (total)) * 100).toFixed(1)) + "%"}
                    </p>
                </div>

                <div className="h-11 w-px bg-gray-300 dark:bg-white/10"/>

                <div className="flex flex-col items-center justify-center">
                    <div className="flex items-center justify-center">
                        <div className="h-2 w-2 rounded-full  bg-[#E8A09A]"/>
                        <p className="ml-1 text-sm font-normal text-gray-600">{unit[1]}</p>
                    </div>
                    <p className="mt-px text-xl font-bold text-navy-700  dark:text-white">
                        {(((pieChartDataValues[1] / (total)) * 100).toFixed(1)) + "%"}
                    </p>
                </div>

                <div className="h-11 w-px bg-gray-300 dark:bg-white/10"/>

                <div className="flex flex-col items-center justify-center">
                    <div className="flex items-center justify-center">
                        <div className="h-2 w-2 rounded-full bg-[#FBE29F]"/>
                        <p className="ml-1 text-sm font-normal text-gray-600">{unit[2]}</p>
                    </div>
                    <p className="mt-px text-xl font-bold text-navy-700 dark:text-white">
                        {(((pieChartDataValues[2] / (total)) * 100).toFixed(1)) + "%"}
                    </p>
                </div>

                <div className="h-11 w-px bg-gray-300 dark:bg-white/10"/>

                <div className="flex flex-col items-center justify-center">
                    <div className="flex items-center justify-center">
                        <div className="h-2 w-2 rounded-full bg-[#C6D68F]"/>
                        <p className="ml-1 text-sm font-normal text-gray-600">{unit[3]}</p>
                    </div>
                    <p className="mt-px text-xl font-bold text-navy-700 dark:text-white">
                        {(((pieChartDataValues[3] / (total)) * 100).toFixed(1)) + "%"}
                    </p>
                </div>
            </div>
        </Card>
    );
};

export default EnergySavingsConsumptionGraph;
